export default __webpack_public_path__ + "static/media/thumb2.27446f0f.png";